import { CompanyLogoComponent } from "./components/company-logo.component";
import { ComparisonSymbolLegendsComponent } from "./components/comparison-symbol-legends.component";
import { ComparisonSymbolsLastPriceComponent } from "./components/comparison-symbols-last-price.component";
import { DrawLimitAlertsImageComponent } from "./components/draw-limit-alerts-image.component";
import { DrawLimitAlertsComponent } from "./components/draw-limit-alerts.component";
import { DrawOrderExecutionComponent } from "./components/draw-order-execution.component";
import { DrawSmartRiskComponent } from "./components/draw-smart-risk.component";
import { DrawSwingExitComponent } from "./components/draw-swing-exit.component";
import { DrawTradeOrdersComponent } from "./components/draw-trade-orders.component";
import { DrawTradePriceAnnotationComponent } from "./components/draw-trade-price-annotation.model";
import { DrawingToolsManager } from "./components/drawing-tools/drawing-tools.manager";
import { EarningNotificationComponent } from "./components/earning-notification.component";
import { HaltedNotificationComponent } from "./components/halted-notification.component";
import { HighChartAnnotationPopupComponent } from "./components/highchart-annotation-popup.component";
import { HistoricalChartButtonComponent } from "./components/historical-chart-button.component";
import { IndicatorLastPriceComponent } from "./components/indicators-last-price.component";
import { LastPriceComponent } from "./components/last-price.component";
import { PnlComponent } from "./components/pnl.component";
import { PnPSwitchComponent } from "./components/pnp-switch.component";
import { TiChartSeriesComponent } from "./components/ti-chart-series.component";
import { TILogoComponent } from "./components/ti-logo.component";
import { TooltipComponent } from "./components/tooltip.component";
import { BaseChartContainer } from "./models/base/base-chart.container";
import { Timeframe } from "./models/enum/timeframe.enum";
import { WindowFormChartDataService } from "./services/window-form-chart-data.service";
import { TiChartMenuContainer } from "./ti-chart-menu.container";
import { TiChartPnpContainer } from "./ti-chart-pnp.container";
declare const window: any;
declare const global: any;

global.jQuery = require("jquery");
global.$ = global.jQuery;
require('../node_modules/spectrum-colorpicker2');
declare global {
    interface JQuery {
        spectrum(config: any): void;
    }
}

export class TiChartContainer extends BaseChartContainer {
    private tiChartMenu: TiChartMenuContainer | null = null;

    public pnpContainer: TiChartPnpContainer | null = null;
    public pnpSwitchComponent: PnPSwitchComponent | null = null;
    
    //TODO: Pass in the ChartDataService as a dependency 
    constructor() {
        super();

        this.element = document.body.findFirst('.ti-chart.ti-pro');
        this.chartService = new WindowFormChartDataService(this);
        this.drawingToolsManager = new DrawingToolsManager(this);
        
        const chartMenuElement = this.body.findFirst('.chart-menu-box');
        if (chartMenuElement == null) {
           console.error('ERROR: .chart-menu-box element not found, html needs to be udpated')
           return;
        }

        //Note: the menu needs to be created before the chart series, since HighChart Indicators calls IndicatorLastPrice
        this.tiChartMenu = new TiChartMenuContainer(chartMenuElement, this);
        this.pnpContainer = new TiChartPnpContainer(this);

        this.subscribeChartRequestingNewSymbol();
        this.createTIChartSeriesComponent();
        this.createHighChartAnnotationPopupComponent();
        this.createCompanyLogoComponent();
        this.createPnlComponent();
        this.createHaltedNotificationComponent();
        this.createEarningNotificationComponent();
        this.createIndicatorsLastPriceComponent();
        this.createLastPriceComponent();
        this.createTILogoComponent();
        this.createTradePlotLinesComponent();
        this.createLimitAlertsComponent();
        this.createHistoricalChartButtonComponent();
        this.createDrawOrderExecutionComponent();
        this.createDrawLimitAlertsImageComponent();
        this.createDrawTradePriceAnnotationComponent();
        this.createSmartRisksComponent();
        this.createComparisonSymbolLegendsComponent();
        this.createComparisonSymbolsLastPriceComponent();
        this.createTooltipComponent();
        this.createPnPSwitchComponent();
    }

    private createTIChartSeriesComponent() {
        // this.element.querySelectorAll<HTMLElement>('.ti-chart').forEach((el: HTMLElement) => {
            this.tiChartSeries = new TiChartSeriesComponent(this.element, this);
            this.components.push(this.tiChartSeries);
        // });
            
        this.drawingToolsManager?.subscribeForPopupChange();
    }

    private createHighChartAnnotationPopupComponent() {   
        this.components.push(new HighChartAnnotationPopupComponent(this));
    }

    private createPnlComponent() {
        this.element.querySelectorAll<HTMLElement>('.pnl-container').forEach((el: HTMLElement) => {
            this.components.push(new PnlComponent(el, this));
        });
    }

    private createHaltedNotificationComponent() {
        this.element.querySelectorAll<HTMLElement>('.halted-notification-container').forEach((el: HTMLElement) => {
            this.components.push(new HaltedNotificationComponent(el, this));
        });
    }

    private createEarningNotificationComponent() {
        this.element.querySelectorAll<HTMLElement>('.earning-notification-container').forEach((el: HTMLElement) => {
            this.components.push(new EarningNotificationComponent(el, this));
        });
    }

    private createLastPriceComponent() {
        this.element.querySelectorAll<HTMLElement>('.main-symbol-last-price').forEach((el: HTMLElement) => {
            this.components.push(new LastPriceComponent(el, this));
        });
    }

    private createIndicatorsLastPriceComponent() {
        this.element.querySelectorAll<HTMLElement>('.indicator-last-prices').forEach((el: HTMLElement) => {
            this.components.push(new IndicatorLastPriceComponent(el, this));
        });
    }

    private createComparisonSymbolLegendsComponent() {
        this.element.querySelectorAll<HTMLElement>('.menu-box.comparison-box').forEach((el: HTMLElement) => {
            this.components.push(new ComparisonSymbolLegendsComponent(el, this));
        });
    }

    private createComparisonSymbolsLastPriceComponent() {
        this.element.querySelectorAll<HTMLElement>('.comparison-symbol-last-prices').forEach((el: HTMLElement) => {
            this.components.push(new ComparisonSymbolsLastPriceComponent(el, this));
        });
    }

    private createCompanyLogoComponent() {
        this.element.querySelectorAll<HTMLElement>('.logo-box').forEach((el: HTMLElement) => {
            this.components.push(new CompanyLogoComponent(el, this));
        });
    }

    private createTILogoComponent() {
        this.element.querySelectorAll<HTMLElement>('.logo-wrapper').forEach((el: HTMLElement) => {
            this.components.push(new TILogoComponent(el, this));
        });
    }

    private createTradePlotLinesComponent() {
        this.components.push(new DrawTradeOrdersComponent(this));
    }
    
    private createLimitAlertsComponent() {
        this.components.push(new DrawLimitAlertsComponent(this));
    }
    
    private createHistoricalChartButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.historical-chart-button').forEach((el: HTMLElement) => {
            this.components.push(new HistoricalChartButtonComponent(el, this));
        });
    }

    private createDrawOrderExecutionComponent() {
        this.components.push(new DrawOrderExecutionComponent(this));
    }

    private createDrawLimitAlertsImageComponent() {
        this.components.push(new DrawLimitAlertsImageComponent(this));
    }

    private createDrawTradePriceAnnotationComponent() {
        this.components.push(new DrawTradePriceAnnotationComponent(this));
    }

    private createSmartRisksComponent() {
        this.element.querySelectorAll<HTMLElement>('.smart-risk-wrapper').forEach((el: HTMLElement) => {
            this.components.push(new DrawSwingExitComponent(el, this));
            this.components.push(new DrawSmartRiskComponent(el, this));
        });
    }

    private createTooltipComponent() {
        this.element.querySelectorAll<HTMLElement>('.tooltip').forEach((el: HTMLElement) => {
            this.components.push(new TooltipComponent(el, this));
        });
    }

    private createPnPSwitchComponent() {
        this.element.findFirst('.pnp-switch').ifExistThen((el: HTMLElement) => {
            this.pnpSwitchComponent = new PnPSwitchComponent(el, this);
            this.components.push(this.pnpSwitchComponent);
        });
    }

    private subscribeChartRequestingNewSymbol() {
        this.chartService.subscribeChartRequestingNewSymbolData((symbol: string, timeframe: Timeframe) => {
            this.drawingToolsManager?.clearAll();

            if (!this.tiChartSeries || this.tiChartSeries.symbol != symbol) {
                this.setComponentStateWhenRequestingNewSymbol(symbol, timeframe);
            }
        });
    }

    public override setComponentStateWhenRequestingNewSymbol(symbol: string, timeframe: Timeframe) {
        const pnlComponent = this.getComponentsByType(PnlComponent)[0] as PnlComponent;
        pnlComponent?.hideElements();

        const earningComponent = this.getComponentsByType(EarningNotificationComponent)[0] as EarningNotificationComponent;
        earningComponent?.hide();

        const drawOrderExecutionComponent = this.getComponentsByType(DrawOrderExecutionComponent)[0] as DrawOrderExecutionComponent;
        drawOrderExecutionComponent?.remove();

        const drawTradeOrdersComponent = this.getComponentsByType(DrawTradeOrdersComponent)[0] as DrawTradeOrdersComponent;
        drawTradeOrdersComponent?.remove();

        const drawLimitAlertsComponent = this.getComponentsByType(DrawLimitAlertsComponent)[0] as DrawLimitAlertsComponent;
        drawLimitAlertsComponent?.remove();

        const drawSwingExitComponent = this.getComponentsByType(DrawSwingExitComponent)[0] as DrawSwingExitComponent;
        drawSwingExitComponent?.remove();

        const drawSmartRiskComponent = this.getComponentsByType(DrawSmartRiskComponent)[0] as DrawSmartRiskComponent;
        drawSmartRiskComponent?.remove();
        
        const drawTradePriceAnnotationComponent = this.getComponentsByType(DrawTradePriceAnnotationComponent)[0] as DrawTradePriceAnnotationComponent;
        drawTradePriceAnnotationComponent?.remove();
        
        const drawLimitAlertsImageComponent = this.getComponentsByType(DrawLimitAlertsImageComponent)[0] as DrawLimitAlertsImageComponent;
        drawLimitAlertsImageComponent?.remove();
        
        this.hideTooltip();
        
        if (this.tiChartSeries) {
            this.tiChartSeries.highChartComparisonBuilder?.removeComparisonsComponents(true);
            this.tiChartSeries.currentTimeframe = timeframe;
            this.tiChartSeries.symbol = symbol;
            this.tiChartSeries.setPanel();
            this.tiChartSeries.hideWithOpacity();
            this.tiChartSeries.highChartAxisBuilder?.reset();
        }
    }
}

window.chart = new TiChartContainer();
